import { render, staticRenderFns } from "./TravelAgency.vue?vue&type=template&id=222d3f3c&scoped=true"
import script from "./TravelAgency.vue?vue&type=script&lang=js"
export * from "./TravelAgency.vue?vue&type=script&lang=js"
import style0 from "./TravelAgency.vue?vue&type=style&index=0&id=222d3f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d3f3c",
  null
  
)

export default component.exports